<template>
  <section class="hero-section d-flex align-items-center">
    <div class="container">
      <div class="row align-items-center g-5 mx-0">
        <div class="col-md-6 hero-content">
          <!-- HERO TEXT CAROUSEL -->
          <div class="hero-content-inner">
            <div
              id="marketplaceTextCarousel"
              class="carousel slide"
              data-bs-ride="carousel"
              data-bs-interval="3500"
            >
              <div class="carousel-inner">
                <div class="carousel-item active">
                  <h1 class="fw-bold textprimary mb-3">
                    Discover More. Shop Better.
                  </h1>
                  <p class="mb-4 fs-5 hero-text text-muted">
                    Explore a world of quality products, unbeatable variety, and
                    everyday essentials, all in one convenient marketplace.
                  </p>
                </div>

                <div class="carousel-item">
                  <h1 class="fw-bold textprimary mb-3">
                    Style That Defines You
                  </h1>
                  <p class="mb-4 fs-5 hero-text text-muted">
                    Discover the latest fashion, shoes, bags, and accessories to
                    express your unique style with confidence.
                  </p>
                </div>

                <div class="carousel-item">
                  <h1 class="fw-bold textprimary mb-3">
                    Technology Made Simple
                  </h1>
                  <p class="mb-4 fs-5 hero-text text-muted">
                    Shop smartphones, electronics, and smart devices designed to
                    keep you connected and productive.
                  </p>
                </div>

                <div class="carousel-item">
                  <h1 class="fw-bold textprimary mb-3">
                    Make Your Space Beautiful
                  </h1>
                  <p class="mb-4 fs-5 hero-text text-muted">
                    Transform your home with stylish furniture, décor,
                    appliances, and practical everyday essentials.
                  </p>
                </div>

                <div class="carousel-item">
                  <h1 class="fw-bold textprimary mb-3">
                    Everything You Need, One Place
                  </h1>
                  <p class="mb-4 fs-5 hero-text text-muted">
                    From beauty and personal care to groceries and lifestyle
                    products, discover more of what you love.
                  </p>
                </div>

                <div class="carousel-item">
                  <h1 class="fw-bold textprimary mb-3">
                    Quality Meets Convenience
                  </h1>
                  <p class="mb-4 fs-5 hero-text text-muted">
                    Find great products, explore new possibilities, and enjoy a
                    smarter, more convenient shopping experience.
                  </p>
                </div>
              </div>
            </div>

            <!-- ACTION BUTTONS -->

            <div class="d-flex gap-3 flex-wrap hero-buttons">
              <button
                v-if="!isLoggedIn"
                type="button"
                class="btn btnprimary px-4 fw-semibold"
                @click="openLogin"
              >
                Login
              </button>

              <button
                v-if="isLoggedIn"
                type="button"
                class="btn btnprimary px-4 fw-semibold"
                @click="$router.push({ name: 'Account' })"
              >
                <i class="bi bi-shop me-2"></i>
                Shop Now
              </button>

              <button
                v-if="!isLoggedIn"
                type="button"
                class="btn btnprimary px-4 fw-semibold"
                @click="openLogin"
              >
                <i class="bi bi-shop me-2"></i>
                Shop Now
              </button>

              <button
                v-if="isLoggedIn"
                type="button"
                class="btn btnprimary px-4 fw-semibold"
                @click="$router.push({ name: 'Account' })"
              >
                <i class="bi bi-person-circle me-2"></i>
                See Account
              </button>
            </div>
          </div>
        </div>

        <!-- HERO IMAGE CAROUSEL -->
        <div class="col-md-6">
          <div
            id="heroCarousel"
            class="carousel slide hero-carousel"
            data-bs-ride="carousel"
            data-bs-interval="3000"
          >
            <div class="carousel-inner rounded-4 shadow-lg">
              <!-- <div class="carousel-item active">
                <img
                  src="https://services.libaaxc.com/images/farm/sokoni.jpg"
                  class="hero-carousel-img w-100"
                  alt="Soko mfukoni"
                />
                <div class="carousel-caption">
                  <h5>Soko mfukoni</h5>
                  <p>We have all you need.</p>
                </div>
              </div> -->

              <div class="carousel-item active">
                <img
                  src="https://services.libaaxc.com/images/farm/tomato-tree.jpg"
                  class="hero-carousel-img w-100"
                  alt="Organic vegetables"
                />
                <div class="carousel-caption">
                  <h5>Sell with us</h5>
                  <p>Become part of our journey.</p>
                </div>
              </div>

              <div class="carousel-item">
                <img
                  src="https://services.libaaxc.com/images/farm/onion-tree.jpg"
                  class="hero-carousel-img w-100"
                  alt="Farm products"
                />
                <div class="carousel-caption">
                  <h5>Farm Products Available</h5>
                  <p>Pure goodness from trusted farmers.</p>
                </div>
              </div>
            </div>

            <button
              class="carousel-control-prev"
              type="button"
              data-bs-target="#heroCarousel"
              data-bs-slide="prev"
              aria-label="Previous slide"
            >
              <span class="carousel-control-prev-icon"></span>
            </button>

            <button
              class="carousel-control-next"
              type="button"
              data-bs-target="#heroCarousel"
              data-bs-slide="next"
              aria-label="Next slide"
            >
              <span class="carousel-control-next-icon"></span>
            </button>

            <div class="carousel-indicators">
              <button
                type="button"
                data-bs-target="#heroCarousel"
                data-bs-slide-to="0"
                class="active"
                aria-current="true"
                aria-label="Slide 1"
              ></button>
              <button
                type="button"
                data-bs-target="#heroCarousel"
                data-bs-slide-to="1"
                aria-label="Slide 2"
              ></button>
              <button
                type="button"
                data-bs-target="#heroCarousel"
                data-bs-slide-to="2"
                aria-label="Slide 3"
              ></button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <LoginModal :show="showLogin" @login="onLogin" @close="closeLogin" />
</template>

<script>
import LoginModal from "./Modals/LoginModal.vue";

export default {
  name: "MarketplaceHero",

  components: {
    LoginModal,
  },

  data() {
    return {
      showLogin: false,
      isLoggedIn: false,
      loggedUser: null,
    };
  },

  mounted() {
    this.checkLogin();
  },

  methods: {
    checkLogin() {
      const token = localStorage.getItem("auth_token");

      this.isLoggedIn = !!token;

      try {
        this.loggedUser = JSON.parse(
          localStorage.getItem("user_data") || "null",
        );
      } catch (error) {
        console.error("Failed to parse user data:", error);
        this.loggedUser = null;
      }
    },

    handleShopNow() {
      this.checkLogin();

      if (this.isLoggedIn) {
        this.$router.push({ name: "Account" });
      } else {
        this.openLogin();
      }
    },

    openLogin() {
      this.showLogin = true;
    },

    closeLogin() {
      this.showLogin = false;
    },

    onLogin(credentials) {
      this.loggedUser = credentials?.user || null;
      this.checkLogin();
      this.showLogin = false;
    },
  },
};
</script>

<style>
.hero-section {
  min-height: 100vh;
  padding-top: 40px;
  padding-bottom: 40px;
  background: linear-gradient(135deg, #ecfdf5, #ffffff);
  overflow: hidden;
}

.hero-content {
  position: relative;
  min-height: 500px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.hero-content-inner {
  position: relative;
  z-index: 5;
  width: 100%;
  max-width: 520px;
  margin-top: 25px;
}

.hero-text {
  line-height: 1.6;
  max-width: 500px;
}

.textprimary {
  color: var(--primary-color);
}

.btnprimary {
  color: #fff;
  background: var(--primary-color);
  border: 1px solid var(--primary-color);
  border-radius: 30px;
}

.btnprimary:hover {
  color: #fff;
  background: var(--primary-hover);
}

.btnprimary {
  border-radius: 30px;
}

.shop-link {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
}

.orbit-container {
  position: relative;
  z-index: 6;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 18px;
  padding: 24px 16px;
  text-align: center;
  background: rgba(255, 255, 255, 0.75);
  border: 1px solid rgba(25, 135, 84, 0.12);
  border-radius: 20px;
  box-shadow: 0 10px 30px rgba(25, 135, 84, 0.06);
}

.orbit-logo {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 10px 18px;
  background: var(--card-background, #fff);
  border: 1px solid var(--border-color, #e5eee8);
  border-radius: 14px;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.06);
}

.orbit-logo-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 42px;
  height: 42px;
  flex-shrink: 0;
  color: #fff;
  background: var(--primary-color);
  border-radius: 10px;
  font-size: 22px;
}

.orbit-logo-text {
  color: var(--primary-color);
  font-size: 20px;
  font-weight: 700;
  white-space: nowrap;
}

.orbit-welcome h2 {
  margin: 0 0 8px;
  color: var(--primary-color);
  font-size: 30px;
  font-weight: 800;
}

.orbit-welcome p {
  margin: 0;
  color: var(--muted-color, #777);
  font-size: 15px;
}

.orbit-shop-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 12px 26px;
  color: #fff;
  background: var(--primary-color);
  border: none;
  border-radius: 30px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s ease, transform 0.2s ease;
}

.orbit-shop-btn:hover {
  color: #fff;
  background: var(--primary-hover);
  transform: translateY(-2px);
}

.hero-buttons {
  margin-top: 20px;
}

.hero-carousel {
  position: relative;
}

.carousel-inner {
  border-radius: 16px;
}

.hero-carousel-img {
  display: block;
  height: 420px;
  object-fit: cover;
  width: 100%;
  max-width: 100%;
}

.carousel-caption {
  background: rgba(0, 0, 0, 0.45);
  border-radius: 10px;
  padding: 12px;
  bottom: 20px;
}

.row {
  margin-left: 0 !important;
  margin-right: 0 !important;
}

@media (max-width: 768px) {
  .hero-section {
    text-align: center;
    padding-top: 30px;
    padding-bottom: 40px;
  }

  .hero-content {
    min-height: auto;
  }

  .orbit-container {
    gap: 15px;
    padding: 22px 12px;
  }

  .orbit-welcome h2 {
    font-size: 26px;
  }

  .orbit-welcome p {
    font-size: 14px;
  }

  .orbit-logo-text {
    font-size: 18px;
  }

  .hero-content-inner {
    padding: 10px 5px;
    margin-top: 20px;
  }

  .hero-text {
    margin-left: auto;
    margin-right: auto;
  }

  .hero-buttons {
    justify-content: center;
  }

  .hero-carousel-img {
    height: 280px;
  }
}

@media (max-width: 480px) {
  .orbit-welcome h2 {
    font-size: 23px;
  }

  .orbit-logo {
    padding: 9px 14px;
  }

  .orbit-logo-icon {
    width: 36px;
    height: 36px;
    font-size: 19px;
  }

  .orbit-logo-text {
    font-size: 17px;
  }

  .hero-carousel-img {
    height: 250px;
  }
}
</style>
